module.exports = __webpack_public_path__ + "static/media/mobile_logo.0677f11c.svg";